import { observable, makeObservable, action } from 'mobx';
import { SEARCH_PARAMS } from '../utils/constants';
import { RootStore } from './root';
import { ROUTES } from '../routes';
import { SIGNUP_EMAIL_STORAGE_KEY } from './constants';

export const SSO_PROVIDERS = {
  YELL: 'YELL',
};

export class UserDataStore {
  private readonly rootStore: RootStore;
  public email: string;
  public currentLoggedInEmail: string;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.currentLoggedInEmail = window.__CURRENT_LOGGED_IN_USER_EMAIL__;
    this.email = this.getInitialEmailValue();
    makeObservable(this, {
      email: observable,
      setEmail: action.bound,
    });
  }

  setEmail(email: string) {
    this.email = email;
  }

  private getInitialEmailValue() {
    if (
      this.rootStore.navigationStore.currentRoute === ROUTES.SIGNUP_EMAIL_CODE
    ) {
      try {
        const email = sessionStorage.getItem(SIGNUP_EMAIL_STORAGE_KEY);
        if (email) {
          return email;
        }
      } catch (_) {}
    }
    const emailFromUrl =
      this.rootStore.navigationStore.getQueryParam(SEARCH_PARAMS.EMAIL) ||
      this.rootStore.navigationStore.getQueryParam(
        SEARCH_PARAMS.DEFAULT_EMAIL,
      ) ||
      '';
    return emailFromUrl.replace(/ /g, '+');
  }
}
